import { WorkItemQueryFilterModelPaged } from 'ngx-q360-lib';

export class GetDecisionsPaged {
  static readonly type = '[ProjectTasks] GetDecisionsPaged';
  constructor(public projectId: string) {}
}

export class GetMoreDecisionsPaged {
  static readonly type = '[ProjectTasks] GetMoreDecisionsPaged';
  constructor(public projectId: string) {}
}

export class SetDecisionsQueryFilter {
  static readonly type = '[ProjectDecisions] SetDecisionsQueryFilter';

  constructor(
    public queryFilters: Partial<WorkItemQueryFilterModelPaged>,
    public projectId: string | undefined,
    public kanban = false,
  ) {}
}

export class UpdateDecisionQueryFilter {
  static readonly type = '[ProjectDecisions] UpdateDecisionQueryFilter';
  constructor(
    public queryFilters: Partial<WorkItemQueryFilterModelPaged>,
    public projectId?: string,
  ) {}
}

export class SyncDecisionsQueryParams {
  static readonly type = '[ProjectDecisions] SyncDecisionsQueryParams';
}

export class ResetDecisionQueryFilter {
  static readonly type = '[ProjectDecisions] ResetDecisionQueryFilter';
  constructor(public kanban: boolean) {}
}
